import PageLayout from "@/components/layout/PageLayout";
import { SectionHeading } from "@/components/ui/section-heading";
import MembersMedia from "@/pages/Members/components/MembersMedia";

const Media = () => {
  return (
    <PageLayout>
      <div className="pt-24 pb-12 bg-gray-900 text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold font-display mb-6">
              Media Gallery
            </h1>
            <p className="text-xl text-gray-300">
              Explore photos, videos, and other media from OMAC-UK Taekwondo events and training.
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto py-12 px-4">
        <SectionHeading title="Media" gradient />

        <div className="bg-white shadow-md rounded-lg p-4 md:p-6">
          <MembersMedia publicOnly includeDocuments={false} showCategoryTabs={false} showItemMeta={false} />
        </div>
      </div>
    </PageLayout>
  );
};

export default Media;

